import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";

import {
  CreateProductRequest,
  EditProductRequest,
  Product,
} from "./product.model";

@Injectable()
export class ProductService {
  private http = inject(HttpClient);

  getAvailableProductsDetails() {
    return this.http.get<Product[]>("products");
  }

  editProduct(product: EditProductRequest) {
    return this.http.put<Product>("products", product);
  }

  createProduct(product: CreateProductRequest) {
    return this.http.post<Product>("products", product);
  }
}
